<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'accountingUpload.title' | translate"
      [subtitle]="'accountingUpload.important' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="accountingUpload"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "accountingUpload.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "accountingUpload.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="accountingUpload"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #accountingUpload>
  <form [formGroup]="accountingUploadForm">
    <div left-content class="content-container">
      <app-file-uploader
        [label]="'accountingUpload.balance'"
        [control]="balance"
        [controlName]="'balance'"
        [applicationId]="applicationId"
        [uploaderName]="assetName.BALANCE"
        [uploadedFileLabel]="'accountingUpload.balanceFileLabel'"
        [isSummary]="isSummary"
      ></app-file-uploader>
      <app-file-uploader
        [label]="'accountingUpload.profitAndLoss'"
        [control]="profitAndLoss"
        [controlName]="'profitAndLoss'"
        [applicationId]="applicationId"
        [uploaderName]="assetName.PROFIT_AND_LOSS"
        [uploadedFileLabel]="'accountingUpload.profitAndLossFileLabel'"
        [isSummary]="isSummary"
      ></app-file-uploader>

      <app-infobox
        [title]="'accountingUpload.infobox.title' | translate"
        [content]="'accountingUpload.infobox.content' | translate"
      >
      </app-infobox>
    </div>
  </form>
</ng-template>
